<cipx-quote-request-intake-form
  (stepChanged)="onIntakeFormStepChanged($event)"
  (complete)="onIntakeFormComplete()"
  [showCancelButton]="true"
  (cancelRequestQuote)="onCancelRequestQuote()"
  (confirmationCloseRequested)="onConfirmationCloseRequested()"></cipx-quote-request-intake-form>
